
// 插件路由
const water = () => import(/* webpackChunkName: "example" */ '~/addon/water/pages/water.vue')

const routes = [
	{ 
        path: '/water', 
        component: water 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/water/router/index.js